<script lang="ts">
	import { page } from '$app/stores';
	import ArrowRight from '$lib/assets/images/icons/arrow-right-dark.svg?component';
	import __ from '$lib/stores/TranslationStore';
	import { twMerge } from 'tailwind-merge';

	export let goto: string;
	export let caption = $__('Crédito Habitação');
	export let title: string;
	let className: string = '';
	export { className as class };
</script>

<a
	href={$page.data?.location.origin + goto}
	class={twMerge(
		'flex w-full flex-col overflow-hidden rounded-xl text-white md:flex-row lg:h-[460px] lg:flex-col lg:rounded-3xl',
		className
	)}
>
	<figure class="h-56 w-full overflow-hidden md:w-64 lg:w-full">
		<slot name="image">
			<img
				class="h-full w-full scale-125 object-cover transition-transform duration-75 hover:scale-125"
				alt="foo"
			/>
		</slot>
	</figure>
	<div
		class="flex flex-col items-center justify-center gap-2 bg-dark px-8 py-6 text-center md:items-start md:text-left lg:h-[8em] lg:flex-1 lg:items-center lg:text-center"
	>
		<h3 class="text-xs font-semibold uppercase tracking-0.14 text-primary-light">
			{caption}
		</h3>
		<h2 class="mt-2 text-2xl font-semibold">{title}</h2>
	</div>
	<div
		class="flex items-center justify-center gap-4 bg-primary-light p-4 text-dark md:w-40 md:shrink-0 md:grow-0 md:flex-col lg:h-14 lg:w-auto lg:flex-row"
	>
		<p class="font-semibold md:whitespace-nowrap">{$__('Fazer simulação')}</p>
		<ArrowRight class="fill-dark md:order-first lg:order-last" />
	</div>
</a>
